import React from "react"
import { createIcon } from "@chakra-ui/react"

export const Low = createIcon({
  viewBox: "0 0 56 56",
  defaultProps: {
    width: "56",
    height: "56",
    fill: "none",
  },
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.181.001c7.79-.063 15.386 2.946 20.738 8.477 5.218 5.392 7.171 12.849 7.078 20.27-.092 7.318-2.293 14.596-7.582 19.777-5.294 5.185-12.74 7.363-20.233 7.47-7.62.11-15.418-1.644-20.836-6.883C1.904 43.85-.078 36.23.002 28.748c.08-7.395 2.546-14.6 7.78-19.94C13.128 3.354 20.454.063 28.182.001z"
        fill="#fff"
      />
      <path
        d="M34.165 20.03l-1.288.77 1.288-.77zm6.937 11.631l1.288-.768-1.288.768zm-27.277 9.516l.863-1.227-.864 1.227zm2.362-8.747l.768-1.288-2.576-1.537-.769 1.288 2.577 1.537zm-4.172 5.713l-1.492.161 1.492-.161zm31.97 0l1.492.161-1.492-.161zm-1.81 3.034l-.862-1.227.862 1.227zM29.81 14.372l-.594 1.378.594-1.378zM14.73 23.916l-1.03 1.09 2.18 2.06 1.03-1.09-2.18-2.06zm11.46-9.544l-.595-1.377.594 1.377zm2.484 8.332l-.167-1.491-2.981.334.166 1.49 2.982-.333zm-2.088 8.313l.167 1.49 2.981-.333-.167-1.49-2.981.333zM28.94 34.9h-1.5v3h1.5v-3zm.02 3h1.5v-3h-1.5v3zm3.916-17.1l6.936 11.63 2.577-1.537-6.936-11.63-2.577 1.536zm2.06 19.7H21.063v3h13.872v-3zm-13.873 0c-2.052 0-3.49-.001-4.566-.097-1.086-.096-1.557-.274-1.81-.453l-1.726 2.454c.916.645 2.04.878 3.27.987 1.24.11 2.837.109 4.832.109v-3zm-7.454-9.607c-.996 1.67-1.799 3.014-2.323 4.114-.52 1.092-.885 2.177-.764 3.297l2.983-.323c-.03-.272.036-.731.49-1.684.45-.943 1.164-2.145 2.19-3.867l-2.576-1.537zm1.078 9.057a2.781 2.781 0 01-1.182-1.97l-2.982.325a5.781 5.781 0 002.438 4.1l1.726-2.455zm25.125-7.52c1.027 1.722 1.742 2.924 2.191 3.867.454.953.52 1.412.49 1.684l2.983.323c.121-1.12-.244-2.205-.764-3.297-.524-1.1-1.327-2.443-2.323-4.114l-2.577 1.537zM34.936 43.5c1.995 0 3.591.001 4.831-.109 1.23-.109 2.355-.342 3.271-.987l-1.725-2.454c-.254.179-.726.357-1.811.453-1.076.096-2.514.097-4.566.097v3zm7.558-5.52a2.782 2.782 0 01-1.181 1.97l1.725 2.454a5.781 5.781 0 002.439-4.1l-2.983-.323zm-7.04-18.717c-.997-1.671-1.796-3.015-2.518-4.004-.72-.986-1.498-1.818-2.532-2.264l-1.188 2.755c.286.123.674.424 1.296 1.277.62.85 1.338 2.05 2.365 3.772l2.577-1.537zM16.91 25.977c.835-.884 1.822-1.954 2.843-3.063a406.923 406.923 0 013.088-3.324 82.14 82.14 0 012.675-2.735c.375-.36.69-.646.939-.851.286-.236.377-.275.328-.254l-1.188-2.755c-.379.163-.756.452-1.05.695-.33.273-.706.616-1.107 1a84.67 84.67 0 00-2.78 2.841 408.223 408.223 0 00-3.11 3.35c-1.027 1.113-1.999 2.168-2.818 3.035l2.18 2.06zm13.492-12.982a6.084 6.084 0 00-4.806 0l1.187 2.755a3.083 3.083 0 012.432 0l1.188-2.755zm-4.71 10.042l.894 7.98 2.981-.334-.893-7.98-2.982.334zM28.942 37.9h.02v-3h-.02v3z"
        fill="currentColor"
      />
    </>
  ),
})

export const Moderate = createIcon({
  viewBox: "0 0 56 56",
  defaultProps: {
    width: "56",
    height: "56",
    fill: "none",
  },
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.181.001c7.79-.063 15.386 2.946 20.738 8.477 5.218 5.392 7.171 12.849 7.078 20.27-.092 7.318-2.293 14.596-7.582 19.777-5.294 5.185-12.74 7.363-20.233 7.47-7.62.11-15.418-1.644-20.836-6.883C1.904 43.85-.078 36.23.002 28.748c.08-7.395 2.546-14.6 7.78-19.94C13.128 3.354 20.454.063 28.182.001z"
        fill="#fff"
      />
      <path
        d="M15.116 29.127c1.62 1.57 5.891 3.778 10.02.045m16.568-1.451c-1.69 1.4-6.019 3.53-9.81.859m-7.478 8.163c.526 6.08 8.549 8.012 9.226-.808m14.279-8.997c1.055 12.196-8.654 20.854-19.633 21-10.978.147-18.46-6.259-20.1-17.521-1.64-11.262 7.687-21.38 18.056-22.288 10.37-.908 20.622 6.613 21.677 18.81z"
        stroke="currentColor"
        strokeWidth="3"
      />
    </>
  ),
})

export const Good = createIcon({
  viewBox: "0 0 56 56",
  defaultProps: {
    width: "56",
    height: "56",
    fill: "none",
  },
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.181.001c7.79-.063 15.386 2.946 20.738 8.477 5.218 5.392 7.171 12.849 7.078 20.27-.092 7.318-2.293 14.596-7.582 19.777-5.294 5.185-12.74 7.363-20.233 7.47-7.62.11-15.418-1.644-20.836-6.883C1.904 43.85-.078 36.23.002 28.748c.08-7.395 2.546-14.6 7.78-19.94C13.128 3.354 20.454.063 28.182.001z"
        fill="#fff"
      />
      <path
        d="M47.92 26.938c1.056 12.196-8.653 20.854-19.632 21-10.978.147-18.46-6.259-20.1-17.521-1.64-11.262 7.687-21.38 18.056-22.288 10.37-.908 20.622 6.613 21.677 18.81z"
        stroke="currentColor"
        strokeWidth="2.5"
      />
      <path
        d="M21.276 33.014c-5.38.373-7.242-1.865-8.276-4.196 4.786 0 10.53-.246 16.034-.803 5.204-.525 10.196-1.328 13.966-2.46 0 0-.517 4.662-5.173 5.594-4.655.932-6.379-1.778-8.793-3.134 0 0-2.379 4.626-7.758 4.999z"
        fill="currentColor"
      />
      <path
        d="M29.034 28.015c-5.505.557-11.248.803-16.034.803 1.034 2.331 2.896 4.569 8.276 4.196 5.38-.373 7.758-4.999 7.758-4.999zm0 0c5.204-.525 10.196-1.328 13.966-2.46 0 0-.517 4.662-5.173 5.594-4.655.932-6.379-1.778-8.793-3.134zM24.418 36.741c.526 6.08 8.549 8.012 9.226-.807"
        stroke="currentColor"
        strokeWidth="2.5"
      />
    </>
  ),
})
